<template lang="html">
  <div class="edit-site-colours tier tier-three">
    <Tooltip
      content="Apply a background colour to your site. Colour strength will adjust per theme."
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <PageHeader>
        <div class="heading">
          <h1>
            Site Background Colour
          </h1>
        </div>
      </PageHeader>

      <div class="helper-text">
        <p>
          This is the background colour of your website. This colour will
          automatically adjust if the
          <router-link
            :to="{
              name: 'theme-settings',
              params: {companyId: this.companyId, siteId: this.siteId}
            }"
          >
            theme
          </router-link>
          is light or dark.
        </p>
      </div>

      <hr />

      <SiteColourForm
        @submit="submitSite"
        @setBackground="setIframeBackground"
        v-model="site"
        :colors="colors"
        :errors="errors"
        :activeColor="activeColor"
      />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'
import SiteColourForm from '@/components/forms/SiteColourForm'
import Tooltip from '@/components/Tooltip'
import PageHeader from '@/components/PageHeader'

export default {
  name: 'EditSiteTheme',

  components: {
    SiteColourForm,
    PageHeader,
    Tooltip
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {},
      colors: [
        {
          id: 11,
          value: '#b7b7b7'
        },
        {
          id: 11,
          value: '#404040'
        },
        {
          id: 13,
          value: '#205766'
        },
        {
          id: 14,
          value: '#4e7d52'
        },
        {
          id: 15,
          value: '#d4bd46'
        },
        {
          id: 16,
          value: '#bb6212'
        },
        {
          id: 17,
          value: '#7e3434'
        },
        {
          id: 18,
          value: '#935f83'
        },
        {
          id: 19,
          value: '#744f8b'
        },
        {
          id: 20,
          value: '#5e8176'
        }
      ]
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} Colour`
    },

    activeColor() {
      return this.site.background_color
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'colour', 'applied')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
